
import React from 'react';

import useDeviceType, { MOBILE, TABLET } from '../../Utilidades/useDeviceType';

import { AdmisionProvider } from './Context/store'

//components 
import { HomeMobile } from './Mobile/HomeMobile';
import { HomeDesktop } from './HomeDesktop';
import { HomeTablet } from './Tablet/HomeTablet';

const Home = () => {

    const deviceType = useDeviceType();

    return (
        <AdmisionProvider>
        <React.Fragment>
            {deviceType === MOBILE ? (
            
                  <HomeMobile />
               
            ) : deviceType === TABLET ? (
                <HomeTablet/>
            ) : (
                <HomeDesktop/>
            )}
        </React.Fragment>
        </AdmisionProvider>
    )
}
 
export default Home;
